import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoginState {
    token: string | null;
    isAuthenticated: boolean | null;
    isLoginOtp: boolean;
}

const initialState: LoginState = {
    token: localStorage.getItem('token') ?? null,
    isAuthenticated: false,
    isLoginOtp: false,
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        isLoginFunc: (state, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload;
        },
        isLoginOtpFunc: (state, action: PayloadAction<boolean>) => {
            state.isLoginOtp = action.payload;
        },
    },
});

export const { isLoginFunc,isLoginOtpFunc } = loginSlice.actions;

export default loginSlice.reducer;
